/* eslint-disable */
import React, { useEffect, useState } from 'react';
import styles from './staffing.module.scss';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import StaffingProjection from './HiringForecast/ hiringForecast';

const Staffing = () => { 
  const [isMobileView, setIsMobileView] = useState(false);
  const [staffingValue, setStaffingValue] = useState('Dashboard');

  useEffect(() => {
    checkMobileView();
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (event, newValue) => {
    setStaffingValue(newValue);
  };

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const staffingDisplay = () => {
    switch (staffingValue) {
      case 'Dashboard':
        return <StaffingProjection />;
      case 'Staffing Detailed':
        return '';
      case 'Tagging resources':
        return '';
      default:
        return <StaffingProjection />;
    }
  };

  return (
    <div className={styles['scopeDetails-container']}>
      <div className={styles['scopeDetails-mainText']}>Staffing Projection</div>
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={staffingValue}
          textColor={'#6B5CE8'}
          indicatorColor={'#6B5CE8'}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            width: isMobileView ? screen.width :'100%',
            borderBottom: '1px solid #7A757F',
            '& .MuiTabs-indicator': {
              backgroundColor: '#6B5CE8',
            },
            '& .Mui-selected': {
              color: '#6B5CE8',  
            },
          }}
          aria-label="wrapped label tabs example"
        >
          <Tab value="Dashboard" label="Dashboard" sx={{fontFamily: 'Mukta', minWidth: !isMobileView ? 200 : 'auto', textTransform: 'none', fontSize: !isMobileView ? 16 : 14, fontWeight: staffingValue === 'Dashboard' ? '600' : '400' }} />
          <Tab value="Staffing Detailed" label="Staffing Detailed" sx={{fontFamily: 'Mukta', minWidth: !isMobileView ? 200 : 'auto', textTransform: 'none', fontSize: !isMobileView ? 16 : 14, fontWeight: staffingValue === 'Staffing Detailed' ? '600' : '400' }} />
          <Tab value="Tagging resources" label="Tagging resources" sx={{ fontFamily: 'Mukta', minWidth: !isMobileView ? 200 : 'auto', textTransform: 'none', fontSize: !isMobileView ? 16 : 14, fontWeight: staffingValue === 'Tagging resources' ? '600' : '400' }} />
        </Tabs>
      </Box>
      {staffingDisplay()}
    </div>
  );
};

export default Staffing;
